import { SimpleShowLayout, Show, TextField, BooleanField, Labeled } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const ShowDirections = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show title="Детайли за направление">
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="КСК">
              <BooleanField source="providesCampaigns" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="КСК с различни изпити">
              <BooleanField source="canCandidateWithDifferentExams" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Отделна КСК кампания за платено обучение">
              <BooleanField source={"hasSeparatePaidCampaign"} />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDirections;
